// extracted by mini-css-extract-plugin
export default {"liveRegion":"lKX8b"};